/* 三國逗陣打 · 會員（瀏覽器端）
 * 登入／註冊／信箱驗證碼／忘記密碼的視窗、Google 登入與綁定、帳號管理。
 * 伺服器端在 server/accounts.ts、server/auth-http.ts；session 是 HttpOnly cookie，這裡只拿得到 /api/me 回傳的公開資料。
 * 單機頁面（沒有連線伺服器）時 available 為 false，介面就不顯示會員功能。 */
// @ts-nocheck — 和 home.ts 一樣，型別之後補
import { SG } from '../core/sg.ts';

const $ = (id) => document.getElementById(id);
const esc = (t) => String(t == null ? '' : t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
const post = (p, b) => fetch(p, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(b || {}) })
  .then((r) => r.json().catch(() => ({ ok: false, err: '伺服器沒有回應' }))).catch(() => ({ ok: false, err: '連不上伺服器' }));

const A = {
  available: false, user: null, google: false,
  listeners: [],
  onChange(fn) { this.listeners.push(fn); },
  set(u) { this.user = u || null; if (SG.NET) SG.NET.account = this.user; this.listeners.forEach((f) => { try { f(this.user); } catch (e) { console.error(e); } }); },
  async refresh() {
    try {
      const [cfg, me] = await Promise.all([fetch('api/auth/config', { cache: 'no-store' }), fetch('api/me', { cache: 'no-store' })]);
      if (!cfg.ok || !me.ok) throw new Error('no server');
      this.available = true; this.google = !!(await cfg.json()).google;
      this.set((await me.json()).user);
    } catch (e) { this.available = false; this.set(null); }
    return this.user;
  },
  async logout() { await post('api/auth/logout'); this.set(null); toast('已登出'); },
  async setNick(n) { const r = await post('api/me/nick', { nick: n }); if (r.ok) this.set(r.user); return r; },
  open(view, why) { return openAuth(view || 'login', why); },
};
SG.Account = A;
const toast = (t) => (SG.Home ? SG.Home.toast(t) : alert(t));

// ---------- 登入視窗：login / register / verify / forgot / reset 五個畫面切換 ----------
let resolveAuth = null, form = { email: '' }, cooldown = 0, cdTimer = null;
function openAuth(view, why) {
  if (!A.available) { toast('會員功能要從連線伺服器開啟遊戲（npm start）'); return Promise.resolve(null); }
  return new Promise((done) => { resolveAuth = done; render(view, why); $('modal').hidden = false; });
}
function close(u) { $('modal').hidden = true; const f = resolveAuth; resolveAuth = null; if (f) f(u || null); }
function startCooldown() { cooldown = 60; clearInterval(cdTimer); cdTimer = setInterval(() => { cooldown--; const b = $('au-resend'); if (b) { b.disabled = cooldown > 0; b.textContent = cooldown > 0 ? `重新寄送（${cooldown}）` : '重新寄送'; } if (cooldown <= 0) clearInterval(cdTimer); }, 1000); }

function render(view, why) {
  const box = $('modal-box');
  const field = (id, label, type, extra = '') => `<label class="au-f"><span>${label}</span><input id="${id}" type="${type}" ${extra}></label>`;
  const gbtn = A.google ? `<div class="au-or"><span>或</span></div><a class="btn au-google" href="auth/google"><i aria-hidden="true">G</i>使用 Google 帳號登入</a>` : '';
  const head = (t, sub) => `<h3>${t}</h3>${why ? `<p class="au-why">${esc(why)}</p>` : ''}${sub ? `<p class="on-note">${sub}</p>` : ''}`;
  const views = {
    login: () => `${head('登入會員', '登入後排位積分、商域購買與存檔都跟著帳號走。')}
      ${field('au-email', '信箱', 'email', `autocomplete="email" value="${esc(form.email)}"`)}${field('au-pass', '密碼', 'password', 'autocomplete="current-password"')}
      <p class="au-err" id="au-err" role="alert"></p>
      <div class="acts"><button class="btn primary" type="button" id="au-go">登入</button></div>
      <p class="au-links"><button type="button" class="au-link" data-v="forgot">忘記密碼</button><button type="button" class="au-link" data-v="register">還沒有帳號？註冊</button></p>${gbtn}`,
    register: () => `${head('註冊會員', '我們會寄一組驗證碼到你的信箱。')}
      ${field('au-email', '信箱', 'email', `autocomplete="email" value="${esc(form.email)}"`)}${field('au-nick', '暱稱（對戰時顯示，全站唯一）', 'text', `maxlength="12" value="${esc((SG.Meta && SG.Meta.profile.nick) || '')}"`)}
      ${field('au-pass', '密碼（至少 8 個字）', 'password', 'autocomplete="new-password"')}${field('au-pass2', '再輸入一次密碼', 'password', 'autocomplete="new-password"')}
      <p class="au-err" id="au-err" role="alert"></p>
      <p class="au-legal">註冊即表示您同意<a href="terms.html" target="_blank" rel="noopener">服務條款</a>與<a href="privacy.html" target="_blank" rel="noopener">隱私權政策</a>。</p>
      <div class="acts"><button class="btn primary" type="button" id="au-go">註冊並寄送驗證碼</button></div>
      <p class="au-links"><button type="button" class="au-link" data-v="login">已經有帳號？登入</button></p>${gbtn}`,
    verify: () => `${head('驗證信箱', `驗證碼已寄到 <b>${esc(form.email)}</b>，10 分鐘內有效。`)}
      ${field('au-code', '6 位數驗證碼', 'text', 'inputmode="numeric" maxlength="6" autocomplete="one-time-code" class="au-code"')}
      <p class="au-err" id="au-err" role="alert"></p>
      <div class="acts"><button class="btn" type="button" id="au-resend">重新寄送</button><button class="btn primary" type="button" id="au-go">驗證並登入</button></div>`,
    forgot: () => `${head('忘記密碼', '輸入註冊的信箱，我們會寄驗證碼讓你設定新密碼。')}
      ${field('au-email', '信箱', 'email', `autocomplete="email" value="${esc(form.email)}"`)}
      <p class="au-err" id="au-err" role="alert"></p>
      <div class="acts"><button class="btn primary" type="button" id="au-go">寄送驗證碼</button></div>
      <p class="au-links"><button type="button" class="au-link" data-v="login">想起來了，回到登入</button></p>`,
    reset: () => `${head('設定新密碼', `驗證碼已寄到 <b>${esc(form.email)}</b>。設定後其他裝置的登入會被登出。`)}
      ${field('au-code', '6 位數驗證碼', 'text', 'inputmode="numeric" maxlength="6" autocomplete="one-time-code" class="au-code"')}${field('au-pass', '新密碼（至少 8 個字）', 'password', 'autocomplete="new-password"')}
      <p class="au-err" id="au-err" role="alert"></p>
      <div class="acts"><button class="btn primary" type="button" id="au-go">設定並登入</button></div>`,
  };
  box.className = 'modal-box au'; box.dataset.view = view;
  box.innerHTML = `<button type="button" class="au-x" id="au-x" aria-label="關閉">×</button>` + views[view]();
  const err = (t) => { $('au-err').textContent = t || ''; };
  const busy = (on) => { const g = $('au-go'); if (g) { g.disabled = on; } };
  const val = (id) => ($(id) ? $(id).value.trim() : '');
  box.querySelectorAll('.au-link').forEach((b) => { b.onclick = () => { form.email = val('au-email') || form.email; render(b.dataset.v, why); }; });
  $('au-x').onclick = () => close(null);
  $('modal').onclick = (e) => { if (e.target === $('modal')) close(null); };
  const done = (r) => { A.set(r.user); toast(`歡迎，${r.user.nick}`); close(r.user); };
  const go = async () => {
    err(''); busy(true);
    try {
      if (view === 'login') {
        form.email = val('au-email');
        const r = await post('api/auth/login', { email: form.email, password: $('au-pass').value });
        if (r.ok) return done(r);
        if (r.needVerify) { startCooldown(); return render('verify', why); }
        return err(r.err);
      }
      if (view === 'register') {
        form.email = val('au-email');
        if ($('au-pass').value !== $('au-pass2').value) return err('兩次輸入的密碼不一樣');
        const r = await post('api/auth/register', { email: form.email, password: $('au-pass').value, nick: val('au-nick') });
        if (!r.ok) return err(r.err);
        startCooldown(); return render('verify', why);
      }
      if (view === 'verify') { const r = await post('api/auth/verify', { email: form.email, code: val('au-code') }); return r.ok ? done(r) : err(r.err); }
      if (view === 'forgot') { form.email = val('au-email'); const r = await post('api/auth/forgot', { email: form.email }); if (!r.ok) return err(r.err); startCooldown(); return render('reset', why); }
      if (view === 'reset') { const r = await post('api/auth/reset', { email: form.email, code: val('au-code'), password: $('au-pass').value }); return r.ok ? done(r) : err(r.err); }
    } finally { busy(false); }
  };
  $('au-go').onclick = go;
  box.querySelectorAll('input').forEach((i) => { i.onkeydown = (e) => { if (e.key === 'Enter') go(); if (e.key === 'Escape') close(null); }; });
  if ($('au-resend')) {
    $('au-resend').disabled = cooldown > 0; if (cooldown > 0) $('au-resend').textContent = `重新寄送（${cooldown}）`;
    $('au-resend').onclick = async () => { const r = await post('api/auth/resend', { email: form.email }); if (r.ok) { startCooldown(); toast('已重新寄出驗證碼'); } else err(r.err); };
  }
  const first = box.querySelector('input:not([value]), input[value=""]') || box.querySelector('input');
  if (first) first.focus();
}

// ---------- 帳號管理（設定頁的「帳號」區塊） ----------
export function accountPanel() {
  if (!A.available) return `<div class="opt"><b>會員</b><p class="on-note">目前是單機頁面。會員、排位與雲端存檔要從連線伺服器開啟遊戲（npm start）。</p></div>`;
  const u = A.user;
  if (!u) return `<div class="opt acct"><b>會員</b><p class="on-note">登入後排位積分、商域購買與存檔都跟著帳號走，換裝置也不會不見。</p>
    <div class="acct-acts"><button class="btn primary" type="button" data-acct="login">登入</button><button class="btn" type="button" data-acct="register">註冊</button>${A.google ? '<a class="btn au-google" href="auth/google"><i aria-hidden="true">G</i>Google 登入</a>' : ''}</div></div>`;
  return `<div class="opt acct"><b>會員</b>
    <p class="on-note">刪除帳號或查詢個人資料，請寄信至 <a href="mailto:sankuofighter@gmail.com">sankuofighter@gmail.com</a>（<a href="privacy.html" target="_blank" rel="noopener">隱私權政策</a>）。</p>
    <dl class="acct-dl">
      <div><dt>暱稱</dt><dd>${esc(u.nick)} <button class="au-link" type="button" data-acct="nick">修改</button></dd></div>
      <div><dt>ID</dt><dd><b class="pid">${esc(u.pid || '')}</b> <small class="on-note">加好友、查戰績用</small></dd></div>
      ${u.admin ? '<div><dt>管理</dt><dd><a href="admin.html" class="au-link">開啟管理後台 →</a></dd></div>' : ''}
      <div><dt>信箱</dt><dd>${u.email ? esc(u.email) + (u.verified ? ' <span class="ok-tag">已驗證</span>' : ' <span class="warn-tag">未驗證</span>') : '<span class="on-note">（只用 Google 登入）</span>'}</dd></div>
      <div><dt>密碼</dt><dd>${u.hasPass ? '已設定' : '<span class="on-note">尚未設定</span>'} <button class="au-link" type="button" data-acct="pass">${u.hasPass ? '修改' : '設定密碼'}</button></dd></div>
      <div><dt>Google</dt><dd>${u.google ? '已綁定 <button class="au-link" type="button" data-acct="unlink">解除綁定</button>' : A.google ? '<a class="au-link" href="auth/google?link=1">綁定 Google 帳號</a>' : '<span class="on-note">伺服器未啟用 Google 登入</span>'}</dd></div>
    </dl>
    <div class="acct-acts"><button class="btn" type="button" data-acct="logout">登出</button></div></div>`;
}
export function bindAccountPanel(root, rerender) {
  root.querySelectorAll('[data-acct]').forEach((b) => {
    b.onclick = async () => {
      const k = b.dataset.acct;
      if (k === 'login' || k === 'register') { await A.open(k); rerender(); }
      else if (k === 'logout') { await A.logout(); rerender(); }
      else if (k === 'nick') { if (SG.Home) await SG.Home.askNick(); rerender(); }
      else if (k === 'unlink') { const r = await post('api/me/google/unlink'); if (r.ok) { A.set(r.user); toast('已解除 Google 綁定'); } else toast(r.err); rerender(); }
      else if (k === 'pass') { await passwordBox(); rerender(); }
    };
  });
}
function passwordBox() {
  return new Promise((ok) => {
    const u = A.user, box = $('modal-box');
    box.className = 'modal-box au';
    box.innerHTML = `<button type="button" class="au-x" id="au-x" aria-label="關閉">×</button><h3>${u.hasPass ? '修改密碼' : '設定密碼'}</h3>
      ${u.hasPass ? '<label class="au-f"><span>目前的密碼</span><input id="pw-old" type="password" autocomplete="current-password"></label>' : '<p class="on-note">設定之後也可以用信箱＋密碼登入。</p>'}
      <label class="au-f"><span>新密碼（至少 8 個字）</span><input id="pw-new" type="password" autocomplete="new-password"></label>
      <p class="au-err" id="au-err" role="alert"></p><div class="acts"><button class="btn primary" type="button" id="pw-go">儲存</button></div>`;
    $('modal').hidden = false;
    const close2 = () => { $('modal').hidden = true; ok(); };
    $('au-x').onclick = close2;
    $('pw-go').onclick = async () => { const r = await post('api/me/password', { old: $('pw-old') ? $('pw-old').value : '', password: $('pw-new').value }); if (r.ok) { A.set(r.user); toast('密碼已更新'); close2(); } else $('au-err').textContent = r.err; };
    (box.querySelector('input')).focus();
  });
}

// 從 Google 回來：網址帶著結果
try {
  const q = new URLSearchParams(location.search);
  const e = q.get('login_error'), linked = q.get('linked');
  if (e || linked) { setTimeout(() => toast(e ? '登入失敗：' + e : '已綁定 Google 帳號'), 600); history.replaceState(null, '', location.pathname + location.hash); }
} catch (e) { /* 忽略 */ }
A.ready = A.refresh();
